import GreenCardOeder from './views/main.c.js';
export default GreenCardOeder;
